import React from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Cloud, Mail, Building2, Timer, UserCog } from "lucide-react";
import { SETTINGS } from "@/constants/testIds";
import { useAuth } from "@/lib/auth";
import { useSettings } from "@/hooks/useSettings";
import { GraphSettings } from "@/components/settings/GraphSettings";
import { SmtpSettings } from "@/components/settings/SmtpSettings";
import { BrandingSettings } from "@/components/settings/BrandingSettings";
import { SyncSettings } from "@/components/settings/SyncSettings";
import { ProfileSettings } from "@/components/settings/ProfileSettings";

export default function Settings() {
  const { user, refreshUser } = useAuth();
  const {
    settings,
    graph, setGraph,
    smtp, setSmtp,
    branding, setBranding,
    sync, setSync,
    testResult, testing,
    saveGraph, testGraph, saveSmtp, saveBranding, saveSync, saveProfile,
  } = useSettings();

  return (
    <div className="space-y-6">
      <div>
        <div className="text-[11px] font-semibold uppercase tracking-[0.14em] text-orange-600 mb-1">
          Sistema
        </div>
        <h1 className="text-3xl font-semibold tracking-tight text-slate-900">Configuración</h1>
        <p className="text-sm text-slate-500 mt-1">
          Credenciales Microsoft Graph, SMTP, identidad corporativa y sincronización.
        </p>
      </div>

      <Tabs defaultValue="graph">
        <TabsList className="bg-slate-100">
          <TabsTrigger value="graph" data-testid={SETTINGS.tabGraph}>
            <Cloud className="w-3.5 h-3.5 mr-1.5" strokeWidth={1.75} /> Microsoft Graph
          </TabsTrigger>
          <TabsTrigger value="smtp" data-testid={SETTINGS.tabSmtp}>
            <Mail className="w-3.5 h-3.5 mr-1.5" strokeWidth={1.75} /> SMTP
          </TabsTrigger>
          <TabsTrigger value="branding" data-testid={SETTINGS.tabBranding}>
            <Building2 className="w-3.5 h-3.5 mr-1.5" strokeWidth={1.75} /> Identidad
          </TabsTrigger>
          <TabsTrigger value="sync" data-testid={SETTINGS.tabSync}>
            <Timer className="w-3.5 h-3.5 mr-1.5" strokeWidth={1.75} /> Sincronización
          </TabsTrigger>
          <TabsTrigger value="profile" data-testid={SETTINGS.tabProfile}>
            <UserCog className="w-3.5 h-3.5 mr-1.5" strokeWidth={1.75} /> Mi perfil
          </TabsTrigger>
        </TabsList>

        <TabsContent value="graph" className="mt-4">
          <GraphSettings
            settings={settings}
            graph={graph} setGraph={setGraph}
            testResult={testResult} testing={testing}
            onSave={saveGraph} onTest={testGraph}
          />
        </TabsContent>

        <TabsContent value="smtp" className="mt-4">
          <SmtpSettings settings={settings} smtp={smtp} setSmtp={setSmtp} onSave={saveSmtp} />
        </TabsContent>

        <TabsContent value="branding" className="mt-4">
          <BrandingSettings branding={branding} setBranding={setBranding} onSave={saveBranding} />
        </TabsContent>

        <TabsContent value="sync" className="mt-4">
          <SyncSettings settings={settings} sync={sync} setSync={setSync} onSave={saveSync} />
        </TabsContent>

        <TabsContent value="profile" className="mt-4">
          <ProfileSettings user={user} refreshUser={refreshUser} onSave={saveProfile} />
        </TabsContent>
      </Tabs>
    </div>
  );
}
